import React, { useState, useEffect, useMemo } from "react"
import {
  Container,
  Form,
  Card,
  CardBody,
  FormGroup,
  Input,
  Label,
  Table,
  Button,
  Row,
  Col,
} from "reactstrap"
import axios from "axios"
import { useDispatch, useSelector } from "react-redux"
import {
  getAttendStudList,
  getCurrentAcadid,
  markAbsentStud,
  getAttendReportReset,
} from "store/actions"
import { Tbody, Thead } from "react-super-responsive-table"
import Spinners from "components/Common/Spinner"
import { toast } from "react-toastify"
import moment from "moment/moment"
import { debounce } from "lodash"
import AbsentPop from "./AbsentPop"
import PresentAll from "./PresentAll"
const Attendance = () => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const [searchText, setSearchText] = useState("")
  const [debouncedSearch, setDebouncedSearch] = useState("")

  const [presentStuds, setPresentStuds] = useState([])
  const [absentModal, setAbsentModal] = useState(false)
  const [presentModal, setPresentModal] = useState(false)

  const togglePresent = () => setPresentModal(!presentModal)

  const [isNotification, setNotification] = useState([])

  const debouncedChangeHandler = useMemo(
    () =>
      debounce(value => {
        setDebouncedSearch(value)
      }, 300),
    []
  )

  useEffect(() => {
    debouncedChangeHandler(searchText)
  }, [searchText, debouncedChangeHandler])

  const { studList, AbsentList, Loading, errors, successMsg } = useSelector(
    state => state.AttendanceReducer
  )

  const token = JSON.parse(localStorage.getItem("Token"))
  const [div, setDiv] = useState([])
  const { acadID } = useSelector(state => state.CommonReducer)
  const [Adata, setAData] = useState()
  const [inputData, setInputData] = useState({
    acad_id: "",
    abdate: "",
    sort_order_select: "",
  })

  const toggleModal = () => setAbsentModal(!absentModal)

  const handleConfirm = () => {
    toggleModal()
  }

  const handlePresentConfirm = () => {
    if (onConfirm) onConfirm()
    togglePresent()
  }
  const filteredStudents = studList.filter(student => {
    const nameMatch = student.name
      .toLowerCase()
      .includes(searchText.toLowerCase())

    if (student.blocked_at === "0000-00-00" || !student.blocked_at) {
      return nameMatch
    }

    const abDate = new Date(inputData.abdate)
    const blockedDate = new Date(student.blocked_at)

    return nameMatch && abDate < blockedDate
  })

  const [checkBox, setCheckBox] = useState({
    webCheck: 0,
    appCheck: 0,
    emailCheck: 0,
    smsCheck: 0,
  })

  console.log(isNotification, "isNotification")
  useEffect(() => {
    if (isNotification.length > 0) {
      setCheckBox({
        webCheck: isNotification.includes("web") ? 1 : 0,
        appCheck: isNotification.includes("app") ? 1 : 0,
        emailCheck: isNotification.includes("email") ? 1 : 0,
        smsCheck: isNotification.includes("sms") ? 1 : 0,
      })
    }
  }, [isNotification])

  const [abStudData, setAbStudData] = useState({
    allStdUserIdsArr: [],
    abStdUserIdsArr: [],
    destination: [],
  })

  const [checkboxesList, setCheckboxesList] = useState({})
  const [selectAll, setSelectAll] = useState(false)

  const handleCheckBox = inputCheck => {
    setCheckBox({
      ...checkBox,
      [inputCheck.target.name]: inputCheck.target.checked ? 1 : 0,
    })
  }

  const handleInputChange1 = e => {
    const { classdiv, classid } = JSON.parse(e.target.value)
    // console.log(e.target.value)
    setInputData({
      ...inputData,
      classdiv_id: classdiv,
      class_id: classid,
    })
  }

  const handleInputChange = inputs => {
    setInputData({
      ...inputData,
      [inputs.target.name]: inputs.target.value,
    })
  }

  const handleStudCheck = checkInput => {
    const { value, checked } = checkInput.target

    setCheckboxesList(prev => ({
      ...prev,
      [value]: checked,
    }))

    if (checked) {
      setAbStudData(prevState => ({
        ...prevState,
        abStdUserIdsArr: [...prevState.abStdUserIdsArr, value],
      }))
    } else {
      setAbStudData(prevState => ({
        ...prevState,
        abStdUserIdsArr: prevState.abStdUserIdsArr.filter(id => id !== value),
      }))
    }
  }

  const handleSelectAll = () => {
    const newSelectAll = !selectAll
    setSelectAll(newSelectAll)

    const updatedCheckboxes = {}
    const selectedIds = []

    filteredStudents.forEach(student => {
      updatedCheckboxes[student.user_id] = newSelectAll
      if (newSelectAll) {
        selectedIds.push(student.user_id.toString())
      }
    })

    setCheckboxesList(updatedCheckboxes)
    setAbStudData(prev => ({
      ...prev,
      abStdUserIdsArr: newSelectAll ? selectedIds : [],
    }))
  }

  useEffect(() => {
    const allChecked =
      filteredStudents.length > 0 &&
      filteredStudents.every(student => checkboxesList[student.user_id])

    setSelectAll(allChecked)
  }, [checkboxesList, filteredStudents])

  const InsertStudAllToArray = () => {
    let AllStudents = []
    for (let i = 0; i < studList.length; i++) {
      AllStudents.push(studList[i].user_id)
    }
    return AllStudents
  }

  //  SUBMIT ATTENDANCE
  const submitData = () => {
    const data = {
      acad_id: inputData.acad_id,
      class_id: inputData.class_id,
      classdiv_id: inputData.classdiv_id,
      abdate: moment(inputData.abdate).format("DD-MM-YYYY"),
      sort_order_select: parseInt(inputData.sort_order_select),
      // student_list: abStudData.abStdUserIdsArr,
      destination: abStudData.destination,
    }

    setAData(data)
    setAbsentModal(true)

    // dispatch(markAbsentStud({ data }))

    // setShowAbsentModal(false)
  }
  const PresentAllButton = () => {
    const data = {
      acad_id: inputData.acad_id,
      class_id: inputData.class_id,
      classdiv_id: inputData.classdiv_id,
      abdate: moment(inputData.abdate).format("DD-MM-YYYY"),
      sort_order_select: parseInt(inputData.sort_order_select),
      student_list: abStudData.abStdUserIdsArr,
      destination: abStudData.destination,
    }
    // setPresentStuds(data)
    // setPresentModal(true)
    dispatch(markAbsentStud({ data }))
  }

  useEffect(() => {
    if (errors && errors !== null) {
      toast.error(errors)
    }
    if (successMsg && successMsg !== null) {
      dispatch(getAttendReportReset())
      toast.success(successMsg)
    }
  }, [errors, successMsg])

  useEffect(() => {
    if (studList && Array.isArray(studList)) {
      const AllStud = InsertStudAllToArray(studList)
      setAbStudData({
        ...abStudData,
        allStdUserIdsArr: AllStud,
      })
    }
  }, [studList])

  useEffect(() => {
    if (acadID.acadid) {
      setInputData({ ...inputData, acad_id: acadID.acadid })
    }
  }, [acadID])

  useEffect(() => {
    if (localStorage.getItem("sid")) {
      dispatch(
        getCurrentAcadid({
          sid: localStorage.getItem("sid"),
        })
      )
    }
  }, [])

  useEffect(() => {
    dispatch(getAttendReportReset())
    const currentDate = new Date()
    const year = currentDate.getFullYear()
    const month = String(currentDate.getMonth() + 1).padStart(2, "0")
    const day = String(currentDate.getDate()).padStart(2, "0")
    const formattedDate = `${year}-${month}-${day}`

    setInputData(prev => ({
      ...prev,
      abdate: formattedDate,
    }))
  }, [])

  useEffect(() => {
    ///show-students-attendance
    const getClassDiv = async () => {
      try {
        await axios({
          method: "POST",
          url: "https://marcopolo.prisms.in/api/examfillmarks/get-classdiv-list",
          data: {
            acad_id: acadID.acadid,
          },
          headers: {
            Authorization: token,
          },
        }).then(res => {
          setDiv(res.data.data)
        })
      } catch (error) {
        console.log(error)
      }
    }

    if (acadID.acadid) {
      getClassDiv()
    }
  }, [acadID.acadid])

  useEffect(() => {
    const getHolidays = async ({ acad, classdiv, abdate }) => {
      const data = {
        acad_id: acad,
        classdiv_id: classdiv,
        abdate: abdate,
      }
      try {
        await axios({
          method: "POST",
          url: "https://marcopolo.prisms.in/api/attendance/check-student-holidays",
          data: data,
          headers: {
            Authorization: token,
          },
        }).then(res => {
          // setDiv(res.data.data);
        })
      } catch (error) {
        console.log(error)
      }
    }

    if (acadID.acadid && inputData.classdiv_id && inputData.abdate) {
      getHolidays({
        acad: acadID.acadid,
        classdiv: inputData.classdiv_id,
        abdate: inputData.abdate,
      })
    }
  }, [acadID.acadid, inputData.classdiv_id, inputData.abdate])

  useEffect(() => {
    const destinationArray = Object.keys(checkBox)
      .filter(key => checkBox[key] === 1)
      .map(key => key.replace("Check", "").toLowerCase())

    setAbStudData(prev => ({
      ...prev,
      destination: destinationArray,
    }))
  }, [checkBox])

  useEffect(() => {
    if (
      inputData.acad_id &&
      inputData.classdiv_id &&
      inputData.abdate &&
      inputData.sort_order_select
    ) {
      dispatch(
        getAttendStudList({
          acad_id: inputData.acad_id,
          classdiv_id: inputData.classdiv_id,
          abdate: moment(inputData.abdate).format("DD-MM-YYYY"),
          sortOrderSelect: parseInt(inputData.sort_order_select),
          frommodule: "attendance",
          userside: "teacherside",
        })
      )
    }
  }, [inputData])

  useEffect(() => {
    if (studList && AbsentList) {
      const newCheckboxes = {}

      const absentStudentIds = AbsentList.map(absent => String(absent.user_id))

      const updatedAbStdUserIdsArr = studList
        .filter(student => absentStudentIds.includes(String(student.user_id)))
        .map(student => String(student.user_id))

      studList.forEach(student => {
        const isAbsent = absentStudentIds.includes(String(student.user_id))
        newCheckboxes[String(student.user_id)] = isAbsent
      })

      setCheckboxesList(newCheckboxes)
      setAbStudData(prevState => ({
        ...prevState,
        abStdUserIdsArr: updatedAbStdUserIdsArr,
      }))
    }
  }, [studList, AbsentList])

  useEffect(() => {
    const getNotificationDestination = async () => {
      try {
        setLoading(true)
        await axios({
          method: "POST",
          url: "https://marcopolo.prisms.in/api/teacher-attendanceCenter/getAttendNotiSetting",
          headers: {
            Authorization: token,
          },
        }).then(res => {
          const parsedValues = JSON.parse(res.data.data[0].values)
          setNotification(parsedValues)
          setLoading(false)
        })
      } catch (error) {
        setLoading(false)
      }
    }
    getNotificationDestination()
  }, [])

  if (loading) {
    return (
      <div className="page-content">
        <Spinners />
      </div>
    )
  }
  const today = new Date().toISOString().split("T")[0]

  return (
    <Row className="mt-5 py-4">
      <Card className="p-2">
        <CardBody className="p-2">
          <Container fluid={true}>
            <Form>
              <FormGroup>
                <div className="w-100 d-flex justify-content-around px-0 mx-0">
                  {isNotification[0] == "web" ? (
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        name="webCheck"
                        onClick={e => handleCheckBox(e)}
                        type="checkbox"
                        id="WebSelect"
                        checked={checkBox.webCheck === 1}
                      />
                      <label className="form-check-label" htmlFor="WebSelect">
                        Web
                      </label>{" "}
                    </div>
                  ) : null}
                  {isNotification[1] == "app" ? (
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        name="appCheck"
                        onClick={e => handleCheckBox(e)}
                        type="checkbox"
                        id="appSelect"
                        checked={checkBox.appCheck === 1}
                      />
                      <label className="form-check-label" htmlFor="appSelect">
                        App
                      </label>
                    </div>
                  ) : null}
                  {isNotification[2] == "email" ? (
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        name="emailCheck"
                        onClick={e => handleCheckBox(e)}
                        type="checkbox"
                        id="emailSelect"
                        checked={checkBox.emailCheck === 1}
                      />
                      <label className="form-check-label" htmlFor="emailSelect">
                        Email
                      </label>
                    </div>
                  ) : null}
                  {isNotification[3] == "sms" ? (
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        name="smsCheck"
                        onClick={e => handleCheckBox(e)}
                        type="checkbox"
                        id="smsSelect"
                        checked={checkBox.smsCheck === 1}
                      />
                      <label className="form-check-label" htmlFor="smsSelect">
                        Sms
                      </label>
                    </div>
                  ) : null}
                </div>
              </FormGroup>

              <FormGroup>
                {/* <Label htmlFor="Selectteachers" className="form-label">
                  Class Division
                </Label> */}
                <Input
                  id="Selectteachers"
                  name="classdiv_id"
                  type="select"
                  className="form-control"
                  onChange={handleInputChange1}
                >
                  <option value={""}>Select Divisions</option>
                  {div.length > 0 &&
                    div.map((classDiv, index) => (
                      <option
                        key={classDiv.id}
                        value={JSON.stringify({
                          classdiv: classDiv.id,
                          classid: classDiv.class_id,
                        })}
                      >
                        {classDiv.div_name}
                      </option>
                    ))}
                </Input>
              </FormGroup>
              <FormGroup>
                {/* <Label htmlFor="selectSort" className="form-label">
                  Sort Order
                </Label> */}
                <Input
                  id="selectSort"
                  name="sort_order_select"
                  type="select"
                  className="form-control"
                  onChange={handleInputChange}
                >
                  <option value={""}>Sort Order</option>

                  <option value={1001}>Roll No, Gender, Name</option>
                  <option value={1002}>Gender, Last name</option>
                  <option value={1003}>Last Name</option>
                  <option value={1004}>First Name</option>
                  <option value={1005}>Gr.No</option>
                </Input>
              </FormGroup>

              <FormGroup>
                {/* <Label htmlFor="selectdate" className="form-label">
                  Absent Date
                </Label> */}
                <Input
                  id="selectdate"
                  name="abdate"
                  type="date"
                  value={inputData.abdate}
                  className="form-control"
                  onChange={handleInputChange}
                  max={today}
                />
              </FormGroup>

              <FormGroup>
                <Input
                  name="searchtext"
                  type="text"
                  placeholder="Search by student"
                  className="form-control"
                  value={searchText}
                  onChange={e => setSearchText(e.target.value)}
                />
              </FormGroup>

              <Col>
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <label
                    className="form-check-label fw-bold"
                    htmlFor="selectAllCheckbox"
                  >
                    Select All
                  </label>
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="selectAllCheckbox"
                    checked={selectAll}
                    onChange={handleSelectAll}
                    style={{ transform: "scale(1.2)", margin: "5px" }}
                  />
                </div>
              </Col>

              <Col>
                <div className="d-flex justify-content-between mb-2 mt-2">
                  <span className="fw-bold fs-6">Absent Student</span>
                  <span className="fw-bold fs-6">
                    {abStudData && abStudData.abStdUserIdsArr.length}
                  </span>
                </div>
              </Col>
            </Form>
            {Loading ? (
              <div className="">
                <Spinners />
              </div>
            ) : (
              studList &&
              Array.isArray(studList) &&
              studList.length > 0 && (
                <>
                  <Table className="w-100 table-sm">
                    <Thead>
                      <tr>
                        <th>Roll No</th>
                        <th>Name</th>
                        <th className="text-danger text-center">Absent</th>
                      </tr>
                    </Thead>
                    <Tbody>
                      {filteredStudents.map((data, index) => (
                        <tr key={data.user_id}>
                          <td>{data.roll_no}</td>
                          <td>{data.name}</td>
                          <td className="d-flex justify-content-center align-items-center">
                            <div className="form-check">
                              <input
                                className={`form-check-input ${
                                  checkboxesList[data.user_id]
                                    ? `bg-danger`
                                    : ""
                                }`}
                                type="checkbox"
                                value={data.user_id}
                                checked={checkboxesList[data.user_id] || false}
                                onChange={handleStudCheck}
                                id={`flexCheckChecked${index}`}
                                style={{
                                  transform: "scale(1.2)",
                                  margin: "5px",
                                }}
                              />
                            </div>
                          </td>
                        </tr>
                      ))}
                    </Tbody>
                  </Table>

                  <div className="d-flex justify-content-between  mb-4">
                    <Button color={"success"} onClick={PresentAllButton}>
                      Present All
                    </Button>
                    <Button color={"danger"} onClick={submitData}>
                      Absent
                    </Button>
                  </div>
                </>
              )
            )}
          </Container>
          {absentModal && (
            <AbsentPop
              isOpen={absentModal}
              toggle={toggleModal}
              onConfirm={handleConfirm}
              abStudData={abStudData}
              filteredStudents={filteredStudents}
              Adata={Adata}
            />
          )}

          {presentModal && (
            <PresentAll
              isOpen={presentModal}
              toggle={toggleModal}
              onConfirm={handleConfirm}
              data={presentStuds}
            />
          )}
        </CardBody>
      </Card>
    </Row>
  )
}

export default Attendance
